import { DynamicFieldProps, FieldRenderer } from './dynamic-field.types';
import { DynamicDateField } from './fields/dynamic-date-field';
import { FormField } from '../../dynamic-form.types';

const fieldRenderers: Record<FormField['type'], FieldRenderer> = {
  date: DynamicDateField,
};

export const DynamicField = ({ field, control }: DynamicFieldProps) => {
  const label = field.copy;

  const renderer = fieldRenderers[field.type];

  if (!renderer) {
    throw new Error(`Unsupported field type: ${field.type}`);
  }

  return renderer(field, control, label);
};
